
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fredcon25",
      function () {
        return require("private-next-pages/fredcon25.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fredcon25"])
      });
    }
  